import React from 'react';
import * as S from './References.styles';
import { FacebookOutlined, GlobalOutlined, InstagramOutlined } from '@ant-design/icons';
import { useAppSetting } from '@app/contexts/AppSettingContext';

export const References: React.FC = () => {
  const { storeName } = useAppSetting();

  return (
    <S.ReferencesWrapper>
      <S.Text>{storeName || 'Hoa Chân Thật'} &copy; 2025</S.Text>
      <S.Icons>
        <a href="https://hoachanthat.com/" target="_blank" rel="noreferrer">
          <GlobalOutlined />
        </a>
        <a href="https://www.facebook.com/HoaChanThat.HCM?mibextid=LQQJ4d" target="_blank" rel="noreferrer">
          <FacebookOutlined />
        </a>
        <a href="https://www.instagram.com/hoachanthat.trulyflower/" target="_blank" rel="noreferrer">
          <InstagramOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
